import { render, staticRenderFns } from "./CreateUserPage.vue?vue&type=template&id=01fd3626"
import script from "./CreateUserPage.vue?vue&type=script&lang=js"
export * from "./CreateUserPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports